const slideDown = (target, duration = 500) => {
  target.style.removeProperty('display');

  if (window.getComputedStyle(target).display === 'none') {
    target.style.display = 'block';
  }

  const height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight; // force reflow

  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.height = `${height}px`;

  ['paddingTop', 'paddingBottom', 'marginTop', 'marginBottom'].forEach((prop) => {
    target.style.removeProperty(prop.replace(/([A-Z])/g, '-$1').toLowerCase());
  });

  window.setTimeout(() => {
    ['height', 'overflow', 'transition-duration', 'transition-property'].forEach((prop) => {
      target.style.removeProperty(prop);
    });
  }, duration);
};

export default slideDown;
